export enum ClientStatus {
  All = -1,
  Potential = 1,
  Inactive = 2,
  Active = 3,
  ActiveAndPotential = 4
}